import ErrorMapContent from "./ErrorMapContent";

export default ErrorMapContent;
